import { render, staticRenderFns } from "./itineraryItem.vue?vue&type=template&id=24b8ec94&scoped=true&"
import script from "./itineraryItem.vue?vue&type=script&lang=js&"
export * from "./itineraryItem.vue?vue&type=script&lang=js&"
import style0 from "./itineraryItem.vue?vue&type=style&index=0&id=24b8ec94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8ec94",
  null
  
)

export default component.exports